import type { QueryFunction, QueryKey } from '@tanstack/react-query'

import type { ServiceGetAllResponse } from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { HistoryItem } from './types'

const QUERY_KEY = (key?: string | Record<string, any>) =>
  ['activity-history', key] as const

interface InfiniteQueryOptions<T> {
  queryKey: QueryKey
  initialPageParam: number
  getNextPageParam: (lastPage: ServiceGetAllResponse<T>) => number | undefined
  queryFn: QueryFunction<ServiceGetAllResponse<T>, QueryKey, number>
}

const getAllInfinite = (
  params?: Record<string, any>
): InfiniteQueryOptions<HistoryItem[]> => ({
  queryKey: QUERY_KEY(params),
  initialPageParam: 1,
  getNextPageParam: (lastPage: ServiceGetAllResponse<HistoryItem[]>) => {
    const meta = lastPage.meta

    if (!meta) return undefined
    return (meta?.current_page ?? 0) < (meta?.last_page ?? 0)
      ? (meta?.current_page ?? 0) + 1
      : undefined
  },
  queryFn: async ({ pageParam }: { pageParam: number }) => {
    try {
      const response = await api.get<ServiceGetAllResponse<HistoryItem[]>>(
        `${params?.identifier}/histories`,
        {
          params: {
            ...params,
            identifier: undefined,
            page: pageParam
          }
        }
      )

      return {
        message: response.data.message,
        meta: response.data.meta,
        data: response.data.data
      }
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const activityHistory = {
  getAllInfinite
}
